export enum StepMore {
  Upload = 'Upload',
  Create = 'Create',
  Receive = 'Receive',
}
